<div
  class="profile-header-configuration"
  id="profile-header-configuration-page"
>
  <ptg-breadcrumb
    [listBreadcrumbs]="listBreadcrumbs"
    (onAdd)="addProfileConfig()"
    buttonAddLabel="New Header"
  ></ptg-breadcrumb>

  <div *ngIf="bannerType" class="p-6">
    <ptg-banner [(bannerType)]="bannerType" [message]="message"></ptg-banner>
  </div>

  <ptg-grid
    [data]="profileHeaderConfigurationsData"
    [columns]="columns"
    [isLoading]="isLoading"
    [paginable]="false"
    [errorMessage]="errorMsg"
    [hideScrollbar]="false"
    (sortChange)="sortChange($event)"
    notFoundMessage="No Profile Header View to Display"
  >
    <ng-template cellContent columnName="statuses" let-row>
      <ptg-list-status [statusList]="row.statuses"></ptg-list-status>
    </ng-template>
    <ng-template cellContent columnName="action" let-row>
      <ptg-button
        buttonName="Edit"
        classInput="edit-button"
        (clickButton)="editRecord(row)"
      >
        <mat-icon>edit</mat-icon>
      </ptg-button>
      <ptg-button
        *ngIf="!row.isStatic"
        buttonName="Remove"
        classInput="remove-button"
        (clickButton)="removeRecord(row)"
      >
        <mat-icon>delete_forever</mat-icon>
      </ptg-button>
    </ng-template>
  </ptg-grid>
</div>
